import { useToast } from "@chakra-ui/react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useClinic } from "../../../../components/Context/ClinicaContext";
import ConvenioService from "../../../../services/ADM/ConvenioService";

export const useConvenios = () => {
  const { selectedClinic } = useClinic();

  return useQuery({
    queryKey: ["convenios", selectedClinic?._id],
    queryFn: () => ConvenioService.getAll(selectedClinic._id),
    enabled: !!selectedClinic?._id,
    refetchOnWindowFocus: false,
  });
};

export const useConvenioById = (id) => {
  return useQuery({
    queryKey: ["convenio", id],
    queryFn: () => ConvenioService.getById(id),
    enabled: !!id,
    refetchOnWindowFocus: false,
  });
};

export const useClinicas = () => {
  return useQuery({
    queryKey: ["clinicas"],
    queryFn: () => ConvenioService.getClinicas(),
    refetchOnWindowFocus: false,
  });
};

export const useTabelasProcedimentos = () => {
  const { selectedClinic } = useClinic();
  return useQuery({
    queryKey: ["tabelasProcedimentos", selectedClinic?._id],
    queryFn: () => ConvenioService.getTabelasProcedimentos(selectedClinic._id),
    enabled: !!selectedClinic?._id,
    refetchOnWindowFocus: false,
  });
};

export const useUpsertConvenio = (id) => {
  const queryClient = useQueryClient();
  const toast = useToast();
  const { selectedClinic } = useClinic();

  return useMutation({
    mutationFn: (data) =>
      id ? ConvenioService.update(id, data) : ConvenioService.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["convenios", selectedClinic?._id] });
      toast({
        title: "Sucesso",
        description: `Convênio ${id ? "atualizado" : "cadastrado"} com sucesso.`,
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    },
    onError: (error) => {
      toast({
        title: "Erro",
        description: error.message || "Falha ao salvar convênio.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    },
  });
};

export const useDeleteConvenio = () => {
  const queryClient = useQueryClient();
  const toast = useToast();
  const { selectedClinic } = useClinic();

  return useMutation({
    mutationFn: (id) => ConvenioService.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["convenios", selectedClinic?._id] });
      toast({
        title: "Sucesso",
        description: "Convênio excluído com sucesso.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    },
    onError: (error) => {
      toast({
        title: "Erro",
        description: error.message || "Falha ao excluir convênio.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    },
  });
};
